// extracted by mini-css-extract-plugin
module.exports = {"sectionSpacing":"homepage_sectionSpacing__AjT2i"};